import { render, staticRenderFns } from "./CrmLogin.vue?vue&type=template&id=8f96da42&scoped=true"
import script from "./CrmLogin.vue?vue&type=script&lang=js"
export * from "./CrmLogin.vue?vue&type=script&lang=js"
import style0 from "./CrmLogin.vue?vue&type=style&index=0&id=8f96da42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f96da42",
  null
  
)

export default component.exports